import { createBookingModel } from 'features/Bookings/models'
import { GTBookingItem, IBookingModel } from 'features/Bookings/types'

export interface IBookingCollection {
  items: IBookingModel[]
}
export const createBookingCollection = (bookings: GTBookingItem[]): IBookingCollection => {
  return {
    items: bookings.map((booking) => {
      return createBookingModel(booking)
    })
  }
}
